import React, { Fragment, SyntheticEvent } from 'react';

import { FileItem } from './FileItem';
import { AttachmentFile } from './fileList.types';
import * as Styled from './FilesList.styles';

export interface FilesListProps {
  list: AttachmentFile[];
  item?: null | Record<string, any>;
  downloadButtonLabel?: string;
  onClick: (url: string) => void;
  onDownloadClick: (item: AttachmentFile) => void;
}

const FilesList: React.FC<FilesListProps> = ({
  list = [],
  downloadButtonLabel,
  onDownloadClick,
  onClick,
}) => {
  const onFileClick = (item: AttachmentFile) => (e: SyntheticEvent) => {
    onClick(item.url);
  };

  const downloadFileClickHandler = (item: AttachmentFile) => () => {
    onDownloadClick(item);
  };

  if (list?.length === 0) {
    return <Fragment />;
  }

  return (
    <Styled.FilesWrapper>
      {list?.map((item) => (
        <FileItem
          key={item.id}
          item={item}
          downloadButtonLabel={downloadButtonLabel}
          onFileClick={onFileClick(item)}
          onDonwoadFileClick={downloadFileClickHandler(item)}
        />
      ))}
    </Styled.FilesWrapper>
  );
};

export { FilesList };
